import { h, defineComponent } from 'vue';
import { useCurrentRoute } from '@/ui/routes';

export default defineComponent({
  name: 'EmptyLayout',
  setup() {
    return function render() {
      const currentRoute = useCurrentRoute();
      const classes = [
        currentRoute.value.meta!.disablePadding ? '' : 'p-12',
        currentRoute.value.meta!.classes,
      ];

      return h('div', { class: classes }, [h('router-view')]);
    };
  },
});
